import React from "react";
import { Button, Flex, Text } from "@jsq/ds/core";
import { Icon } from "@jsq/ds/icons";
import { Colors } from "@jsq/ds/styles";
import { SPACING } from "~/styles/variables";
import StateTemplate from "./StateTemplate";

type Props = {
  onChangeSettings: () => void;
  onExit: () => void;
};
const NoTransactionsState = ({ onExit, onChangeSettings }: Props) => {
  return (
    <StateTemplate
      title="No transactions available to sync"
      icon={<Icon type="exclamation-circle" color={Colors.Danger600} size="xx-large" />}
    >
      <Flex flexDirection="column" alignItems="center">
        <Text css={{ textAlign: "center" }} variant="secondary-md">
          There are no transactions within the selected date range available to sync. Please go
          back and confirm the following:
        </Text>
        <ol css={{ marginTop: "25px", marginBottom: 0, textAlign: "left" }}>
          <li>
            <Text variant="secondary-md">The date range selected is accurate</Text>
          </li>
          <li>
            <Text variant="secondary-md">The JSQ IDs are populated and accurate</Text>
          </li>
          <li>
            <Text variant="secondary-md">The GL transactions are posted and ready to sync</Text>
          </li>
        </ol>
        <Flex css={{ marginTop: "25px" }}>
          <Button css={{ marginRight: SPACING.SMALL }} variant="neutral" onClick={onExit}>
            Back to entities
          </Button>
          <Button onClick={onChangeSettings}>Update settings</Button>
        </Flex>
      </Flex>
    </StateTemplate>
  );
};

export default NoTransactionsState;
